import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_sports_kit~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-sports-kit',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_sports_kit~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_walking_fem_v2_sports_kit'
					),
			},
			upsell: {
				routeNames: ['upsell-tai-chi-walking-f', 'upsell-static-tai-chi-sports-kit'],
				experiment: {
					'upsell-tai-chi-walking-f': () =>
						import(
							/* webpackChunkName: "upsell" */ '@/modules/Upsell/instances/experiments/web_tai_chi_walking_fem_v2_sports_kit'
						),
				},
			},
		},
	},
]

export default config
